export const imageUploadUrl = "https://pocrdev1-core-webapi-apim.azure-api.net/pocrdev1-core-webapi";